/*eslint-disable*/
import React, { useState, useMemo } from "react";
import {
    useTable,
    useSortBy,
    useFilters,
} from "react-table";
import classnames from "classnames";
import Preloader from "./preloader";
import siteDetails from "../views/Pages/SiteDetails";
import {Link} from "react-router-dom";

function Table({ columns, data, title, siteId }) {

    const defaultColumn = useMemo(
        () => ({
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setFilter,
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            filterTypes: {
                text: (rows, id, filterValue) => {
                    return rows.filter((row) => {
                        const rowValue = row.values[id].props.children || "";
                        if (typeof rowValue !== "string") {
                            return false;
                        }
                        return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                    });
                },
            },
        },
        useFilters,
        useSortBy,
    );

    const [searchInput, setSearchInput] = useState("");

    const handleSearchInputChange = (event) => {
        const value = event.target.value || "";
        setSearchInput(value);
        setFilter("0", value.toLowerCase()); // add toLowerCase here
    };

    return (
        <>
            <div className="ReactTable -striped -highlight primary-pagination site-pages-table">
                <div className="table-toolbar table-toolbar--search-right">
                    <div className="table-toolbar__search">
                        <label htmlFor="site-pages-search" className="table-toolbar__label">
                            <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
                            <span className="visually-hidden">Search pages</span>
                        </label>
                        <input
                            id="site-pages-search"
                            type="search"
                            placeholder="Search pages…"
                            className="navbar-search-form table-toolbar__input"
                            value={searchInput}
                            onChange={handleSearchInputChange}
                            autoComplete="off"
                        />
                    </div>
                </div>
                {!title ? (
                  <Preloader inline={true} overlay={false}/>
                ) : (
                  <table {...getTableProps()} className="rt-table">
                      <thead className="rt-thead -header">
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr">
                            {headerGroup.headers.map((column, key) => (
                              <th
                                {...column.getHeaderProps(column.getSortByToggleProps())}
                                className={classnames("rt-th", {
                                    "-cursor-pointer": key === 0,
                                    "-sort-asc": column.isSorted && !column.isSortedDesc,
                                    "-sort-desc": column.isSorted && column.isSortedDesc,
                                })}
                                style={ key === 0 ? {width: '70%'} : {width: '30%'} }
                              >
                                  <div className="">
                                      {column.render("Header")}
                                  </div>
                              </th>
                            ))}
                        </tr>
                      ))}
                      </thead>
                      <tbody {...getTableBodyProps()} className="rt-tbody">
                      {rows.length === 0 ? (
                        <tr className="rt-tr rt-tr--empty-filter">
                          <td colSpan={headerGroups[0]?.headers?.length ?? 1} className="rt-td rt-td--empty-message">
                            <i className="fa-solid fa-folder-open me-2" aria-hidden="true" /> No pages in this crawl.
                          </td>
                        </tr>
                      ) : (
                        rows.map((row, i) => {
                          prepareRow(row);
                          return (
                            <tr
                              {...row.getRowProps()}
                              key={row.id}
                              className={classnames(
                                "rt-tr",
                                { " -odd": i % 2 === 0 },
                                { " -even": i % 2 === 1 }
                              )}
                            >
                              {row.cells.map((cell) => (
                                <td {...cell.getCellProps()} className="rt-td">
                                  {cell.render("Cell")}
                                </td>
                              ))}
                            </tr>
                          );
                        })
                      )}
                      </tbody>
                  </table>
                )}
            </div>
        </>
    );
}

export default Table;
